import { axiosInstance as request } from '@api/rest.service'

const api = '/cost-centers'

/**
 * @description POST /cost-centers
 * @returns {AxiosPromise<any>}
 */
export function CREATE_COST_CENTER(name) {
  return request.post(api, { name })
}

/**
 * @description PUT /cost-centers/{id}
 * @returns {AxiosPromise<any>}
 */
export function UPDATE_COST_CENTER(id, name) {
  return request.put(`${api}/${id}`, { name })
}

/**
 * @description GET /cost-centers
 * @returns {AxiosPromise<any>}
 */
export function GET_COST_CENTERS() {
  return request.get(api)
}

/**
 * @description GET /cost-centers/{id}/delete-confirmation
 * @returns {AxiosPromise<any>}
 */
export function COST_CENTER_DELETE_CONFIRMATION(id) {
  return request.get(`${api}/${id}/delete-confirmation`)
}

/**
 * @description DELETE /cost-centers/{id}
 * @returns {AxiosPromise<any>}
 */
export function DELETE_COST_CENTER(id) {
  return request.delete(`${api}/${id}`)
}
